import { ChevronBackIcon } from '../../icons/ChevronBackIcon';
import { BackLabel, StyledBackButton } from './BackButton.styles';
import type { BackButtonProps } from './BackButton.types';

export function BackButton({
  onClick,
  variant = 'default',
  ariaLabel,
  label,
  disabled = false,
}: BackButtonProps) {
  return (
    <StyledBackButton
      type="button"
      onClick={onClick}
      aria-label={ariaLabel ?? label ?? 'Go back'}
      data-variant={variant}
      data-has-label={label ? 'true' : undefined}
      disabled={disabled}
    >
      <ChevronBackIcon />
      {label && <BackLabel>{label}</BackLabel>}
    </StyledBackButton>
  );
}
